/**
 * CheckBox.ts
 * [Readme] --------------------------------------------------------------------------------------
 *
 * 체크박스 입니다.
 *
 * -----------------------------------------------------------------------------------------------
 */

import React, { useState } from 'react';
import styled from 'styled-components';

interface InputProps {
  id?: any;
  fn?: any;
  labelPos?: string;
  line?: any;
  label?: any;
  click?: Boolean;
  checked?: boolean;
  disabled?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

const CheckBoxContainer = styled.div`
  display: inline-block;
  height: 20px;
  &.right {
    label {
      padding: 0 0 0 1.5rem;
      &::before {
        top: 0.6875rem;
        margin-top: -0.75rem;
      }

      &::after {
        top: 50%;
        margin-top: -0.3125rem;
      }
    }
  }

  &.left {
    label {
      padding: 0 1.5rem 0 0;
      &::before {
        left: auto;
        right: 0;
        top: 0.6875rem;
        margin-top: -0.75rem;
      }

      &::after {
        top: 50%;
        left: auto;
        right: 0.25rem;
        margin-top: -0.3125rem;
      }
    }
  }

  &.up {
    label {
      padding: 0 0 1.25rem 0;
      &::before {
        top: auto;
        bottom: 0;
        left: 50%;
        margin-left: -0.625rem;
        margin-top: 0;
      }

      &::after {
        top: auto;
        bottom: 0.5rem;
        left: 50%;
        margin-left: -0.3125rem;
        margin-top: 0;
      }
    }
  }
  &.down {
    label {
      padding: 1.25rem 0 0 0;
      &::before {
        top: 0;
        left: 50%;
        margin-left: -0.625rem;
        margin-top: 0;
      }

      &::after {
        top: 6px;
        left: 50%;
        margin-left: -0.3125rem;
        margin-top: 0;
      }
    }
  }
`;

const Label = styled.label`
  display: flex;
  padding: 0 10px 0 10px;
  position: relative;
  user-select: none;
  &::after {
    content: '';
    position: absolute;
    top: 40%;
    left: 0.3125rem;
    width: 0.5rem;
    height: 0.1875rem;
    margin-top: -0.25rem;
    border-top: 0;
    border-right: 0;
    border-bottom: 3px solid #fff;
    border-left: 3px solid #fff;
    transform: rotate(-45deg) scale(0);
  }
  &::before {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 45%;
    left: 0;
    width: 20px;
    height: 20px;
    margin-top: -0.625rem;
    border: 1px solid #ccc;
    text-align: center;
  }
`;

const Input = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  width: 0.0625rem;
  height: 0.0625rem;
  margin: -0.0625rem;
  overflow: hidden;
  padding: 0;
  position: absolute;

  &:focus + label:before {
    border-color: #ccc;
  }
  &:disabled:focus + label:before {
    border-color: #ccc;
  }
  &:disabled + label:before {
    border: 1px solid #ccc;
    background: #e6e6e6;
  }

  &:disabled:checked + label:before {
    background-color: #ccc;
    border: 1px solid #ccc;
  }
  &:checked + label {
    &::before {
      border: 1px solid #ff671d;
      background-color: #ff671d;
    }

    &::after {
      transform: rotate(-45deg) scale(1);

      transition: transform 200ms ease-out;
      transition: transform 200ms ease-out, -webkit-transform 200ms ease-out;
    }
  }
`;
const Txt = styled.span`
  display: inline-block;
  vertical-align: middle;
  line-height: 1.5;
  color: #333;
  font-size: 13px;
`;
const CustomCheckBox: React.FC<InputProps> = ({ id, label, fn, line, checked, disabled, labelPos, onChange }) => {
  const [click, setClick] = useState(false);
  const handleClick = () => {
    setClick(!click);
    if (fn) {
      fn(!line);
    }
  };

  return (
    <CheckBoxContainer className={labelPos}>
      <Input onChange={onChange} type="checkbox" onClick={handleClick} id={id} checked={checked} disabled={disabled} />

      <Label htmlFor={id} className="checkbox-container">
        <Txt className="txt">{label}</Txt>
      </Label>
    </CheckBoxContainer>
  );
};

export default CustomCheckBox;
